import clsx from 'clsx';
import { formFieldStyles } from '@v2/styles/formFieldStyles';

export const styles = {
  ...formFieldStyles,

  base: clsx(formFieldStyles.base, 'tw-appearance-none tw-cursor-pointer'),

  padding: 'tw-px-3 tw-py-2 tw-pr-9',

  iconContainer: clsx(
    'tw-pointer-events-none tw-absolute tw-inset-y-0 tw-right-0',
    'tw-flex tw-items-center tw-pr-3'
  ),

  chevron: formFieldStyles.fieldIcon,
};
